import { gql, useQuery } from '@apollo/client';

const GET_OTHER_TENANTS_QUESTIONNAIRES = gql`
  query OtherTenantsQuestionnaires {
    getUser {
      companies {
        id
        name
        questionnaires {
          id
          createdAt
          updatedAt
          application {
            id
          }
        }
      }
    }
  }
`;

interface OtherTenantsResult {
  getUser: {
    companies: {
      id: string;
      name: string;
      questionnaires: {
        id: string;
        createdAt: string;
        updatedAt: string;
        application: {
          id: string;
        };
      }[];
    }[];
  };
}

export function useOtherTenantsQuestionnairesQuery() {
  return useQuery<OtherTenantsResult>(GET_OTHER_TENANTS_QUESTIONNAIRES, {});
}
